<template>
  <div id="previewClass4" :style="previewClass4Style">
    <div id="Scroller">
      <TopMarquee :classtype="2" :issue="2"/>
      <div  id="ArticleCotainer">
        <div class="Article"
             v-for="(a,key) in allArticles" @click="viewArticle(a+1,2,$route.params.class)" :key="key">
          <div class="ArticleImg">
            <img :src="require('../assets/2/'+(a+1)+'/cover.jpg')">
          </div>
          <div class="ArticleTitle">
            {{article(a).title}}
          </div>
          <div class="ArticleDate">
            {{article(a).date}}
          </div>
        </div>
      </div>
      <div id="endimg">
        <img src="../assets/end.png"/>
      </div>
    </div>
  </div>
</template>

<script>
import articlesStore_2 from "../store/articlesStore_2"
import pageStackStore from "../store/pageStackStore"
import TopMarquee from "./MarqueePreview";
import store from "../store";

export default {
  name: "class4",
  components:{
    TopMarquee
  },
  data(){
    return {
      allMarquee:[
      ],
      allArticles:[
      ],
      thisMarquee:0,
      scrollerClass3:0
    }
  },
  mounted:function () {
    this.getArticles();
    var scrollerConfig = {
      '//Description' : 'Default scroller with no configuration',
      touchSpeed:1
    };
    this.scrollerClass3 = new Scroller('#previewClass4', scrollerConfig);
  },
  methods:{
    article(id){
      return articlesStore_2.state.articles[id];
    },
    getArticles:function () {
      let list=articlesStore_2.state['class2'].list
      this.allArticles=list
    },
    viewArticle:function(id,issue,thisclass){
      pageStackStore.commit('pushPageStack', this.$route.path)
      this.$router.replace({ name: 'Article',
        params: { id,issue,class:thisclass}})
    },
  },
  computed:{
    previewClass4Style(){
      return {
        height:(store.state.WindowSize.WindowHeightRem-0.9-1.31-1.11-1.31)+'rem'
      }
    }
  }
}
</script>

<style lang="less" scoped>
@fullWidth:11.25rem;
.fullWidhth{
  width: @fullWidth;
}

#previewClass4{
  .fullWidhth();

  background: white;

  #Scroller{
    .fullWidhth();

    #BannerCotainer{
      .fullWidhth();

      position: relative;
      overflow: hidden;
      height:6.34rem;

      .Marquee{
        .fullWidhth();

        position: absolute;
        left:0px;
        top:0px;
      }
    }

    #ArticleCotainer{
      .fullWidhth();

      padding-left:.35rem;
      padding-right:.35rem;

      .Article{
        overflow: hidden;
        background: white;
        width:5.07rem;
        height:5.08rem;
        border-radius:.45rem;
        margin-left: .1rem;
        margin-right: .1rem;
        margin-top:.45rem;
        box-shadow: 0px 0px .15rem .01rem #cccccc;

        .ArticleImg{
          overflow: hidden;
          width: 100%;
          height:2.85rem;

          img{
            width: 100%
          }
        }

        .ArticleTitle{
          color: black;
          width:4.18rem;
          height:1.2rem;
          line-height:.5rem;
          margin-top: .2rem;
          margin-left: .45rem;
          font-size: .33rem;
        }

        .ArticleDate{
          color: #989898;
          width:4.3rem;
          height:.3rem;
          line-height:.3rem;
          margin-left: .45rem;
          margin-top: .25rem;
          font-size: .3rem;
        }
      }
    }


    #endimg{
      width: 2.58rem;
      margin-left: 4.335rem;
      margin-top: .6rem;
      margin-bottom: .9rem;

      img{
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/previewClass4.vue